var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetingRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 446,
    viewBox: "0 0 233 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233 223c-.31 51.013-20.306 125.465-59.994 164.342C134.709 424.857 83.148 444.408 32.309 446H0v-8.53c1.144-57.243 16.44-116.026 61.093-159.755 29.626-29.021 66.03-47.183 104.215-54.712-38.182-7.529-74.59-25.694-104.215-54.712C16.439 124.559 1.144 65.772 0 8.53V0h32.31c50.838 1.592 102.398 21.143 140.696 58.658C212.694 97.535 232.687 171.987 233 223z",
    fill: "#fff"
  })));
}
export default SvgCompetingRight;